import React from "react";
import { useParams } from "react-router-dom";

import { useQueryGetExternalLink } from "@examspark/common-app";
import { Link, VSpace } from "@examspark/common-ui";

import Breadcrumbs from "../../components/common/Breadcrumbs";
import PageHead from "../../components/common/PageHead";
import PageTitle from "../../components/common/PageTitle";
import ResourceTools from "../../components/resources/ResourceTools";

const ExternalLinkRoute = () => {
  const params = useParams<{
    id: string;
  }>();
  const { data } = useQueryGetExternalLink({
    id: params.id,
    sk: "resource#v0",
  });

  if (!params.id) return null;

  const link_data =
    typeof data?.data === "string" ? JSON.parse(data?.data ?? "{}") : {};

  console.log("link_data", link_data);

  return (
    <VSpace size="3rem">
      <PageHead>
        <Breadcrumbs items={Breadcrumbs.Dashboard()} />
        <PageTitle
          subtitle="External Link"
          tools={<ResourceTools resource={data} />}
        >
          {data?.name}
        </PageTitle>
      </PageHead>
      {link_data && (
        <Link href={link_data?.url}>
          This will take you to an external site. Are you sure?
        </Link>
      )}
    </VSpace>
  );
};

export default ExternalLinkRoute;
